// Route changes did not reset the scroll position (reported 2026-08-30: the
// footer's Privacy Policy link "does nothing"). It navigated correctly — but the
// browser kept you at the bottom of the page, and since the footer is identical
// everywhere you landed at the bottom of the new page staring at the same
// footer. Every footer link was affected, not just that one.
//
// Honours a #hash so in-page anchors still work if any are ever added, and
// respects prefers-reduced-motion by not animating for those users.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser resolve the anchor
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduced ? 'auto' : 'smooth' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
